<div
  *ngIf="errorCount"
  id="mach-core-cars-widget-error"
  class="flex justify-center tablet:mb-[24px]"
>
  <idp-error-message
    [errorMessage]="content.errors.errorMessage"
    [cntError]="errorCount"
    [firstErroneousElement]="firstErrorElement"
  ></idp-error-message>
</div>
<form
  id="mach-core-cars-widget-form"
  [ngClass]="{
    'gap-[24px]': !viewSearchOptionExpanded,
    'gap-[8px]': viewSearchOptionExpanded
  }"
  class="flex flex-col items-center tablet:p-[2px] laptop:p-0 laptop:flex-row w-full laptop:items-start laptop:gap-0 tablet:px-0"
  [formGroup]="carsWidgetForm"
  (ngSubmit)="formSubmit($event)"
>
  <!-- Location Search -->
  <div
    id="mach-core-cars-widget-location"
    class="w-[343px] tablet:w-[520px] laptop:w-[198px] ultrawide:w-[292px] laptop:mr-16"
  >
    <idp-location
      (locationClicked)="locationClicked($event)"
      [content]="content.locationContent"
      [error]="locationErrorMessage"
    ></idp-location>
    <div
      *ngIf="locationErrorMessage"
      class="text-caption-medium text-alert mt-8"
    >
      {{ locationErrorMessage }}
    </div>
  </div>

  <div
    [ngClass]="{
      hidden: viewSearchOptionExpanded
    }"
    id="mach-core-cars-widget-view-options"
    class="flex justify-center laptop:hidden"
  >
    <idp-view-search-options
      (expand)="handleDisplayOptions(); $event.stopPropagation()"
      [label]="content.labels.viewSearchOptionsLabel"
    ></idp-view-search-options>
  </div>

  <!-- Pick Up Date -->
  <div
    id="mach-core-cars-widget-pickup-date"
    [ngClass]="{
      hidden: !viewSearchOptionExpanded,
      'laptop:z-10': pickupDateErrorMessage
    }"
    class="relative w-[343px] tablet:w-[520px] laptop:w-[137.5px] ultrawide:w-[162.5px] laptop:!block laptop:mr-[1px]"
  >
    <button
      type="button"
      [id]="content.pickUpDate.triggerElementId"
      class="flex h-[74px] w-full items-center justify-between rounded-02 !rounded-br-none !rounded-bl-none laptop:!rounded-bl-02 laptop:!rounded-tr-none laptop:!rounded-br-none border border-stroke-01 !border-b-0 laptop:!border-b bg-surface-02 px-16"
      (click)="openPickupDatePicker()"
      [attr.aria-label]="content.accessibility.pickUpAriaLabel"
      [ngClass]="{
        'outline-stroke-alert laptop:!border-2 laptop:!border-stroke-alert laptop:!border-b-2':
          pickupDateErrorMessage
      }"
    >
      <div class="flex flex-col items-start">
        <div class="flex items-center gap-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            class="text-icon-primary"
          >
            <path
              d="M13.165 1.68848C13.6922 1.6839 13.8291 2.15448 13.834 2.17188V3.14062C13.834 3.14062 15.6711 3.13597 16.2666 3.14062C16.8477 3.21239 16.875 3.68555 16.875 3.68555V14.6377C16.875 14.6377 16.9167 15.1499 15.9014 15.1826C13.3766 15.188 5.82211 15.1901 1.61133 15.1826C1.19801 15.1323 1.125 14.5771 1.125 14.5771V3.74609C1.125 3.74609 1.19012 3.15236 1.7334 3.14062C2.27219 3.12906 4.13174 3.14042 4.16504 3.14062V2.17188C4.16918 2.15813 4.32181 1.66566 4.83398 1.68848C5.34353 1.71144 5.49711 2.1545 5.50293 2.17188V3.14062H8.30078V2.17188C8.30483 2.15491 8.41982 1.69531 8.96973 1.68848C9.52083 1.68178 9.63518 2.15674 9.63867 2.17188V3.14062H12.4961V2.17188C12.4985 2.15639 12.5772 1.68787 13.165 1.68848ZM2.46387 13.8516H15.5381V7.49707H2.46387V13.8516ZM2.46387 6.16602H15.5381V4.47168H2.46387V6.16602Z"
              fill="currentColor"
            />
          </svg>
          <span
            id="pickup-date-display"
            class="text-label-md-medium text-heading"
          >
            {{ content.pickUpDate.title }}
          </span>
        </div>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        class="text-icon-primary transition-transform duration-200"
        [ngClass]="{ 'rotate-180': isPickupDatePickerOpen }"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6 9L0.75 3H11.25L6 9Z"
          fill="currentColor"
        />
      </svg>
    </button>
    <div class="date-picker" [id]="content.pickUpDate.id"></div>
    <div
      *ngIf="pickupDateErrorMessage"
      class="text-caption-medium text-alert mt-8 hidden laptop:block"
    >
      {{ pickupDateErrorMessage }}
    </div>
  </div>

  <!-- Pick Up Time -->
  <div
    [ngClass]="{
      hidden: !viewSearchOptionExpanded
    }"
    class="-mt-[6px] relative laptop:mt-0 laptop:-ml-[1px] w-[343px] tablet:w-[520px] laptop:w-[137.5px] ultrawide:w-[162.5px] laptop:!block laptop:mr-16"
    id="pickup-time-dropdown-selector"
  >
    <button
      class="dropdown h-[74px] w-full border !border-stroke-01 !rounded-tl-none !rounded-tr-none laptop:!rounded-tr-02 laptop:!rounded-bl-none"
      [ngClass]="{
        'laptop:!border-l-0': !pickupTimeErrorMessage || pickupDateErrorMessage,
        'outline-stroke-alert laptop:!border-2 laptop:!border-stroke-alert':
          pickupTimeErrorMessage
      }"
      [id]="content.pickUpTimeDropdown.id"
    ></button>
    <div
      *ngIf="pickupTimeErrorMessage"
      class="text-caption-medium text-alert mt-8 hidden laptop:block"
      [ngClass]="{
        'laptop:ml-8': pickupDateErrorMessage
      }"
    >
      {{ pickupTimeErrorMessage }}
    </div>
    <div
      *ngIf="pickupDateErrorMessage"
      class="text-caption-medium text-alert mt-8 laptop:hidden"
    >
      {{ pickupDateErrorMessage }}
    </div>
    <div
      *ngIf="pickupTimeErrorMessage"
      class="text-caption-medium text-alert laptop:hidden"
      [ngClass]="{
        'mt-8': !pickupDateErrorMessage,
        'mt-12': pickupDateErrorMessage
      }"
    >
      {{ pickupTimeErrorMessage }}
    </div>
  </div>

  <!-- Drop Off Date -->
  <div
    id="mach-core-cars-widget-dropoff-date"
    [ngClass]="{
      hidden: !viewSearchOptionExpanded,
      'laptop:z-10': dropoffDateErrorMessage
    }"
    class="relative w-[343px] tablet:w-[520px] laptop:w-[141.5px] ultrawide:w-[162.5px] laptop:!block laptop:mr-[1px]"
  >
    <button
      type="button"
      [id]="content.dropOffDate.triggerElementId"
      class="flex h-[74px] w-full items-center justify-between rounded-02 !rounded-br-none !rounded-bl-none laptop:!rounded-bl-02 laptop:!rounded-tr-none laptop:!rounded-br-none border border-stroke-01 !border-b-0 laptop:!border-b bg-surface-02 px-16"
      (click)="openDropoffDatePicker()"
      [attr.aria-label]="content.accessibility.dropOffTimeAriaLabel"
      [ngClass]="{
        'outline-stroke-alert laptop:!border-2 laptop:!border-stroke-alert laptop:!border-b-2':
          dropoffDateErrorMessage
      }"
    >
      <div class="flex flex-col items-start">
        <div class="flex items-center gap-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            class="text-icon-primary"
          >
            <path
              d="M13.165 1.68848C13.6922 1.6839 13.8291 2.15448 13.834 2.17188V3.14062C13.834 3.14062 15.6711 3.13597 16.2666 3.14062C16.8477 3.21239 16.875 3.68555 16.875 3.68555V14.6377C16.875 14.6377 16.9167 15.1499 15.9014 15.1826C13.3766 15.188 5.82211 15.1901 1.61133 15.1826C1.19801 15.1323 1.125 14.5771 1.125 14.5771V3.74609C1.125 3.74609 1.19012 3.15236 1.7334 3.14062C2.27219 3.12906 4.13174 3.14042 4.16504 3.14062V2.17188C4.16918 2.15813 4.32181 1.66566 4.83398 1.68848C5.34353 1.71144 5.49711 2.1545 5.50293 2.17188V3.14062H8.30078V2.17188C8.30483 2.15491 8.41982 1.69531 8.96973 1.68848C9.52083 1.68178 9.63518 2.15674 9.63867 2.17188V3.14062H12.4961V2.17188C12.4985 2.15639 12.5772 1.68787 13.165 1.68848ZM2.46387 13.8516H15.5381V7.49707H2.46387V13.8516ZM2.46387 6.16602H15.5381V4.47168H2.46387V6.16602Z"
              fill="currentColor"
            />
          </svg>
          <span
            id="dropoff-date-display"
            class="text-label-md-medium text-heading"
          >
            {{ content.dropOffDate.title }}
          </span>
        </div>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        class="text-icon-primary transition-transform duration-200"
        [ngClass]="{ 'rotate-180': isDropoffDatePickerOpen }"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6 9L0.75 3H11.25L6 9Z"
          fill="currentColor"
        />
      </svg>
    </button>
    <div class="date-picker" [id]="content.dropOffDate.id"></div>
    <div
      *ngIf="dropoffDateErrorMessage"
      class="text-caption-medium text-alert mt-8 hidden laptop:block"
    >
      {{ dropoffDateErrorMessage }}
    </div>
  </div>

  <!-- Drop Off Time -->
  <div
    id="dropoff-time-dropdown-selector"
    [ngClass]="{
      hidden: !viewSearchOptionExpanded
    }"
    class="-mt-[6px] relative laptop:mt-0 laptop:-ml-[1px] w-[343px] tablet:w-[520px] laptop:w-[137.5px] ultrawide:w-[162.5px] laptop:!block laptop:mr-16"
  >
    <button
      class="dropdown h-[74px] w-full border !border-stroke-01 !rounded-tl-none !rounded-tr-none laptop:!rounded-tr-02 laptop:!rounded-bl-none"
      [ngClass]="{
        'laptop:!border-l-0':
          !dropoffTimeErrorMessage || dropoffDateErrorMessage,
        'outline-stroke-alert laptop:!border-2 laptop:!border-stroke-alert':
          dropoffTimeErrorMessage
      }"
      [id]="content.dropOffTimeDropdown.id"
    ></button>
    <div
      *ngIf="dropoffTimeErrorMessage"
      class="text-caption-medium text-alert mt-8 hidden laptop:block"
      [ngClass]="{
        'laptop:ml-8': dropoffDateErrorMessage
      }"
    >
      {{ dropoffTimeErrorMessage }}
    </div>
    <div
      *ngIf="dropoffDateErrorMessage"
      class="text-caption-medium text-alert mt-8 laptop:hidden text-justify"
    >
      {{ dropoffDateErrorMessage }}
    </div>
    <div
      *ngIf="dropoffTimeErrorMessage"
      class="text-caption-medium text-alert laptop:hidden"
      [ngClass]="{
        'mt-8': !dropoffDateErrorMessage,
        'mt-12': dropoffDateErrorMessage
      }"
    >
      {{ dropoffTimeErrorMessage }}
    </div>
  </div>

  <!-- Search Button -->
  <div
    id="mach-core-cars-widget-submit"
    [ngClass]="{ hidden: !viewSearchOptionExpanded }"
    class="mt-24 laptop:mt-[0px] laptop:flex laptop:items-center laptop:h-[74px] self-center laptop:self-start"
  >
    <button
      #findCarsButtonElement
      type="submit"
      class="button button-primary button-lg w-[343px] tablet:w-[520px] laptop:w-[132px] ultrawide:w-[154px] text-label-md-semibold whitespace-nowrap"
      [attr.aria-label]="content.accessibility.buttonAriaLabel"
      (click)="
        isIntentionalSubmit = true; analyticsEvent.emit(findCarsButtonElement)
      "
    >
      {{ content.labels.buttonLabel }}
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_15646_212187)">
          <path
            d="M12 0V8.80078H10.3994V2.65625L1.13184 12.002L0 10.8604L9.18359 1.60059H3.19824V0H12Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_15646_212187">
            <rect width="12" height="12" fill="currentColor" />
          </clipPath>
        </defs>
      </svg>
    </button>
  </div>

  <!-- Hidden form controls -->
  <input type="hidden" formControlName="locationCode" />
  <input type="hidden" formControlName="pickUpDate" />
  <input type="hidden" formControlName="pickUpTime" />
  <input type="hidden" formControlName="dropOffDate" />
  <input type="hidden" formControlName="dropOffTime" />
</form>
